import { useAuth } from "components/auth";
import { errorMessages } from "./RtkErrorMessages";
import { Button } from "@thrivetribe/mvf.ui.atoms.button";
import { ButtonArrow } from "@thrivetribe/mvf.assets.icons.button-arrow";
import { useNavigate } from "react-router-dom";
import ErrorMessage from "ui/molecules/Errors/ErrorMessage";
import { FetchBaseQueryError } from "@reduxjs/toolkit/dist/query";
import { SerializedError } from "@reduxjs/toolkit";

/**
 * A component to generate/compose various error messages from RTK errors such as 404,500 etc.,
 * @param { FetchBaseQueryError | SerializedError | undefined;} error -  the RTK error
 * @param {boolean? } renderNav - render navigation properties
 */

export interface RtkErrorMessageProps {
  error: FetchBaseQueryError | SerializedError | undefined;
  renderNav?: boolean;
}

const RtkErrorMessage = (props: RtkErrorMessageProps) => {
  let { authService } = useAuth();
  let navigate = useNavigate();
  let { error, renderNav } = props;

  let queryError = error as FetchBaseQueryError;

  if (!queryError || typeof queryError.status !== typeof 0) {
    return (
      <ErrorMessage
        pageTitle={"An unexpected error has occured."}
        pageHeading={"An unexpected error has occured."}
        pageCopy={"An unexpected error has occured."}
      />
    );
  }

  let errorContent = errorMessages.filter((e) => e.code === queryError.status)[0].props;

  if (authService.isAuthenticated()) {
    return (
      <ErrorMessage
        pageTitle={errorContent.pageTitle}
        pageHeading={errorContent.pageHeading}
        pageCopy={errorContent.pageCopy}
      >
        {renderNav === true && (
          <Button
            onClick={() => {
              navigate("/");
            }}
            variant="primary"
            color="primary"
          >
            Head home
            <ButtonArrow />
          </Button>
        )}
        {queryError.status !== 404 && (
          <Button
            onClick={() => {
              window.location.href = `mailto:support@manvfat.com`;
            }}
            variant="primary"
            color="primary"
          >
            Contact The Dugout Support
            <ButtonArrow />
          </Button>
        )}
      </ErrorMessage>
    );
  }

  return (
    <ErrorMessage
      pageTitle={errorContent.pageTitle}
      pageHeading={errorContent.pageHeading}
      pageCopy={errorContent.pageCopy}
    >
      {renderNav === true && (
        <Button
          onClick={() => {
            authService.authorise();
          }}
          variant="primary"
          color="primary"
        >
          Sign In
          <ButtonArrow />
        </Button>
      )}
      {queryError.status !== 404 && (
        <Button
          onClick={() => {
            window.location.href = `mailto:support@manvfat.com`;
          }}
          variant="primary"
          color="primary"
        >
          Contact The Dugout Support
          <ButtonArrow />
        </Button>
      )}
    </ErrorMessage>
  );
};

export default RtkErrorMessage;
